import { getHostedOnboardingConfig, getOrgSdkArgs } from '@onefootprint/fetch-hosted';
import type { FootprintAppearance } from '@onefootprint/footprint-js';

const CLIENT_PUBLIC_KEY_HEADER = 'X-Onboarding-Config-Key';
const KYB_BO_SESSION_AUTHORIZATION_HEADER = 'X-Kyb-Bo-Token';
const AUTH_HEADER = 'x-fp-authorization';

type OnboardingConfigRequestType = {
  authToken?: string;
  kybBoAuthToken?: string;
  obConfig?: string;
};

const getUtokFromSdkTok = async (authToken: string) => {
  if (!authToken.startsWith('sdktok_')) {
    return authToken;
  }

  try {
    const response = await getOrgSdkArgs({
      headers: {
        'X-Fp-Sdk-Args-Token': authToken,
      },
    });

    const args = response.data.args;
    if (args.kind === 'verify_v1' && args.data.authToken) {
      return args.data.authToken;
    }

    return authToken;
  } catch (_) {
    return authToken;
  }
};

const getAuthHeaders = async (payload: OnboardingConfigRequestType) => {
  const headers: Record<string, string> = {};
  const { authToken, kybBoAuthToken, obConfig } = payload;

  if (obConfig) {
    headers[CLIENT_PUBLIC_KEY_HEADER] = obConfig;
  } else if (kybBoAuthToken) {
    headers[KYB_BO_SESSION_AUTHORIZATION_HEADER] = kybBoAuthToken;
  } else if (authToken) {
    headers[AUTH_HEADER] = await getUtokFromSdkTok(authToken);
  }
  return headers;
};

const getOnboardingConfig = async (headers: Record<string, string>) => {
  const { data } = await getHostedOnboardingConfig({ headers });
  return data;
};

const getAppearanceFromObConfig = async (payload: OnboardingConfigRequestType): Promise<FootprintAppearance | null> => {
  const authHeaders = await getAuthHeaders(payload);
  if (!Object.values(authHeaders).length) {
    return null;
  }

  try {
    const config = await getOnboardingConfig(authHeaders);
    return config.appearance || null;
  } catch (_) {
    return null;
  }
};

export default getAppearanceFromObConfig;
